export default {
    path: 'prints',
    name: 'PrintForm',
    component() {
        return import('@/components/print/PrintForm.vue')
    },
    children: [
        {
            path: '',
            name: 'PrintReport',
            component() {
                return import('@/components/print/printReport/PrintReport.vue')
            },
        },
        {
            path: 'printTerm',
            name: 'PrintReportTerm',
            component() {
                return import('@/components/print/printReportTerm/PrintReportTerm')
            },
        },
        {
            path: 'preJudgement',
            name: 'PreJudgement',
            component() {
                return import('@/components/print/preJudgement/PreJudgement')
            },
        },
        {
            path: 'achievementReport',
            name: 'PrintAchievementReport',
            component() {
                return import('@/components/print/achievementReport/PrintAchievementReport')
            },
        },
    ],
}